export default __webpack_public_path__ + "static/media/step-1.af8c4ab0.webp";